import apiClient from './ApiService'

export default {
  getFuncionesSindicales(page = 1, limit = 100, filters = {}) {
    return apiClient.get('/funciones-sindicales', {
      params: {
        page,
        limit,
        ...filters
      }
    })
  },
  
  getAllFuncionesSindicales(filters = {}) {
    return apiClient.get('/funciones-sindicales/all', {
      params: filters
    })
  },
  
  getFuncionSindical(id) {
    return apiClient.get(`/funciones-sindicales/${id}`)
  },
  
  createFuncionSindical(funcionSindical) {
    return apiClient.post('/funciones-sindicales', funcionSindical)
  },
  
  updateFuncionSindical(id, funcionSindical) {
    return apiClient.put(`/funciones-sindicales/${id}`, funcionSindical)
  },
  
  deleteFuncionSindical(id) {
    return apiClient.delete(`/funciones-sindicales/${id}`)
  }
}